"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = require("@/utils/index");
var _index2 = _interopRequireDefault(require("@/components/Enabled/index.vue"));
var _index3 = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _clientsContacts = require("@/api/clients-contacts");
var _clients = require("@/api/clients");
var _admin = require("@/store/modules/admin");
var _admins = require("@/api/admins");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.clientList = [];
    this.listLoading = true;
    this.selectedClientContactId = null;
    this.selectedColumn = '';
    this.securityQuestion = '';
    this.securityAnswer = '';
    this.dateRange = '';
    this.securityDialogVisible = false;
    this.downloadLoading = false;
    this.listQuery = {
      page: 1,
      limit: 10,
      enabled: true,
      isWebsiteRegistered: undefined,
      firstName: undefined,
      clientId: undefined,
      mobileNumber: undefined,
      emailAddress: undefined,
      createdBy: undefined,
      createdTimestamp: undefined,
      sort: 'id,ASC',
      filter: {
        enabled: '$eq',
        isWebsiteRegistered: '$eq',
        firstName: '$contL',
        clientId: '$eq',
        mobileNumber: '$contL',
        emailAddress: '$contL',
        createdBy: '$eq',
        createdTimestamp: '$between'
      }
    };
    this.isMobile = false;
    this.enableTypeOptions = [{
      key: true,
      value: 'Enabled'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  checkMobile() {
    this.isMobile = window.innerWidth <= 768;
  }
  created() {
    this.setQuery();
    this.getList();
    this.getAdminDetails();
    this.checkMobile();
    // Re-check if the user resizes the window
    window.addEventListener('resize', this.checkMobile);
  }
  setQuery() {
    const queries = this.$route.query;
    // loop over queries
    for (const field in queries) {
      let value = queries[field] || undefined;
      if (value === 'null') {
        value = undefined;
      }
      // check if field is present in listQuery, set
      if (field in this.listQuery) {
        this.listQuery[field] = value;
      }
      // check if its createdTimestamp, set for dateRange
      if (field === 'createdTimestamp' && value) {
        const dates = value.split(',');
        const startDate = this.$moment(dates[0], 'YYYY-MM-DD hh:mm a').toDate();
        const endDate = this.$moment(dates[1], 'YYYY-MM-DD hh:mm a').toDate();
        this.dateRange = {
          start: startDate,
          end: endDate
        };
      }
      // check if its approval request list
      if (field === 'approval' && value) {
        this.listQuery.enabled = false;
        this.listQuery.isWebsiteRegistered = true;
      }
    }
  }
  async getList(id = null, column = null) {
    try {
      this.listLoading = true;
      const data = await (0, _clientsContacts.getClientsContacts)((0, _index.getQuery)(this.listQuery));
      // const maskingData: any = {
      //   dataColumn: column,
      //   adminId: this.loggedInAdmin.id,
      //   clientsContactId: id
      // }
      // for (const contact of data.data) {
      //   if (id && contact.id === id && column === 'emailAddress') {
      //     await addMaskingRequest(maskingData)
      //   } else if (contact.emailAddress?.length) {
      //     contact.emailAddress = this.maskSensitiveInfo(contact.emailAddress)
      //   }
      //   if (id && contact.id === id && column === 'fullName') {
      //     await addMaskingRequest(maskingData)
      //   } else if (contact.fullName?.length) {
      //     contact.fullName = this.maskSensitiveInfo(contact.fullName)
      //   }
      //   if (id && contact.id === id && column === 'mobileNumber') {
      //     await addMaskingRequest(maskingData)
      //   } else if (contact.mobileNumber?.length) {
      //     contact.mobileNumber = this.maskSensitiveInfo(contact.mobileNumber)
      //   }
      //   if (id && contact.id === id && column === 'clientName') {
      //     maskingData.clientId = contact.client  .id
      //     await addMaskingRequest(maskingData)
      //   } else if (contact.client.name?.length) {
      //     contact.client.name = this.maskSensitiveInfo(contact.client.name)
      //   }
      // }
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  maskSensitiveInfo(input) {
    if (input.includes('@')) {
      // If it's an email
      const atIndex = input.indexOf('@');
      return input.slice(0, atIndex - 3) + '*' + input.slice(atIndex);
    } else if (input.match(/^\d+$/)) {
      // If it's a mobile number
      return input.slice(0, -4).replace(/\d/g, '*') + input.slice(-4);
    } else {
      // Otherwise, assuming it's a full name
      const nameParts = input.split(' ');
      return nameParts.map((part, index) => index === 0 ? part : '*'.repeat(part.length)).join(' ');
    }
  }
  async getAdminDetails() {
    const adminId = _admin.AdminModule.id;
    this.loggedInAdmin = await (0, _admins.getAdminById)(adminId);
    this.securityQuestion = this.loggedInAdmin.securityQuestion.title;
  }
  showSecurityDialog(id, column) {
    this.selectedClientContactId = id;
    this.selectedColumn = column;
    this.securityDialogVisible = true;
  }
  verifySecurityAnswer() {
    if (this.securityAnswer === this.loggedInAdmin.securityAnswer) {
      this.getList(this.selectedClientContactId, this.selectedColumn);
    }
    this.securityDialogVisible = false;
  }
  async fetchClientList(query = '') {
    try {
      if (query.length > 0) {
        this.clientList = await (0, _clients.getClients)((0, _index.getQuery)({
          limit: 10,
          enabled: true,
          name: query,
          sort: 'name,ASC',
          filter: {
            enabled: '$eq',
            name: '$contL'
          }
        }));
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.listQuery.createdTimestamp = [this.dateRange.start, this.dateRange.end];
    }
    this.getList();
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ClientContactList',
  components: {
    Pagination: _index3.default,
    Enabled: _index2.default
  }
})], default_1);
var _default = exports.default = default_1;